<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-flex
    :class="{md4: !$store.state.app.big_map, md12: $store.state.app.big_map}"
    class="pl-2 mr-1 sm12 xl5 no-gutters ma-0"
    id="map-and-flags"
  >
    <v-row no-gutters>
      <v-col cols="12" >
        <help-link help_id="10" style="float: right" />
        <v-icon
          v-show="!$store.state.app.big_map"
          @click="
            take_snapshot(
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                .report_type_to_generate === '1P1C'
                ? '1p1c_map'
                : 'mpmc_map',
            )
          "
          style="float: right"
          data-html2canvas-ignore
          >mdi-camera
        </v-icon>
        <v-icon
          v-if="!$store.state.app.big_map"
          style="float: right"
          @click="$store.state.app.big_map = !$store.state.app.big_map"
          data-html2canvas-ignore
          >mdi-arrow-expand-all
        </v-icon>
        <v-icon
          v-else
          class="mr-5"
          style="float: right"
          @click="$store.state.app.big_map = !$store.state.app.big_map"
          >mdi-arrow-collapse-all
        </v-icon>
        <slot id="Map"></slot>
      </v-col>

    </v-row>
<!--    <keep-alive>-->
      <mpmc-graphs-importer-exporter
        v-show="this.current_report_to_run !== '1P1C' && !$store.state.app.big_map"
      />
<!--    </keep-alive>-->
  </v-flex>
</template>
<script>
import helpLink from '@/components/application-level/help-system/help-link';
import mpmcGraphsImporterExporter from '@/components/trade-dsm-application/result-components/mpmc-graphs-under-graph/mpmc-graphs-importer-exporter.vue';
import {mapGetters} from 'vuex';

export default {
  name: 'MapContainer',
  components: {
    helpLink,
    mpmcGraphsImporterExporter,
  },
  data: function() {
    return {
      dummy_selection: {},
      photo_selector: false,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(['is_run_cube_valid']),
  },
  methods: {
    take_snapshot(event) {
      this.element2clipboard(event);
      this.photo_selector = false;
      this.dummy_selection = {};
    },
  },
};
</script>
